module.exports = __webpack_public_path__ + "static/media/countdown2.fb44660a.mp3";